<template>
  <div>
    <v-container fluid>
      <v-card elevation="4" tile v-if="!company">
        <v-skeleton-loader type="card"></v-skeleton-loader>
      </v-card>
      <v-card elevation="4" tile v-else>
        <v-card-title class="pa-2 pl-4">
          <v-icon left color="primary">mdi-chair-rolling</v-icon>
          {{ company.name }}
        </v-card-title>
        <v-divider/>
        <v-card-text>
          <div class="d-flex">
            <div class="pa-3 hidden-sm-and-down">
              <div class="company-file-image-background pa-3 mt-3 elevation-15">
                <v-img :src="require('../../assets/paperclip.png')"
                       class="criminal-file-image-paperclip"/>
                <v-img
                  :src="company.picture === null ? require('../../assets/company.png') : apiAttachmentUrl(company.picture)"
                  height="320" width="320" class="rounded"/>
              </div>
            </div>
            <div class="flex-fill pa-3">
              <v-row>
                <v-col sm="12" md="4" lg="4" xl="2" cols="12">
                  <v-text-field v-model="company.iid" type="number" solo dense outlined hint="ID"
                                persistent-hint
                                prepend-inner-icon="mdi-identifier"/>
                </v-col>
                <v-col sm="12" md="4" lg="4" xl="8" cols="12">
                  <v-text-field v-model="company.name" solo dense outlined hint="Name" persistent-hint
                                prepend-inner-icon="mdi-id-card"/>
                </v-col>
                <v-col sm="12" md="4" lg="4" xl="2" cols="12">
                  <v-select solo dense outlined hint="Art" persistent-hint v-model="company.type"
                            :items="companyTypes" item-text="label" item-value="type"
                            prepend-inner-icon="mdi-smart-card-reader-outline"/>
                </v-col>

                <v-col sm="12" md="12" lg="6" xl="6" cols="12">
                  <custom-date-picker :datetime="datePickerValue(company.nextPaymentLicenses)"
                                      :text-field-props="{'color': 'info', 'outlined': true, 'dense': true, 'prependInnerIcon': 'mdi-calendar', 'hint': 'Nächster Zahlungsintervall', 'persistentHint': true}"
                                      :time-picker-props="{'format': '24hr'}"
                                      v-on:input="modifyEvent_nextPaymentLicenses"/>
                </v-col>
                <v-col sm="12" md="12" lg="6" xl="6" cols="12">
                  <custom-date-picker :datetime="datePickerValue(company.vacatedUntil)"
                                      :text-field-props="{'color': 'info', 'outlined': true, 'dense': true, 'prependInnerIcon': 'mdi-beach', 'hint': 'Urlaub bis', 'persistentHint': true}"
                                      :time-picker-props="{'format': '24hr'}"
                                      v-on:input="modifyEvent_vacatedUntil"/>
                </v-col>
                <v-col sm="12" md="12" lg="6" xl="6" cols="12">
                  <v-text-field
                    readonly
                    dense
                    outlined
                    :value="nextInspectionDateComputed ? visualizeDateOnly(nextInspectionDateComputed) : 'Keine Kontrolle eingetragen'"
                    hint="Nächste Kontrolle"
                    persistent-hint
                    :color="nextInspectionDateComputed && isNextInspectionOverdue ? 'error' : 'info'"
                    :prepend-inner-icon="nextInspectionDateComputed && isNextInspectionOverdue ? 'mdi-alert-circle-outline' : 'mdi-clipboard-check-outline'"
                  />
                </v-col>

                <v-col sm="12" md="12" lg="4" xl="4" cols="12">
                  <v-text-field v-model="company.location" solo dense outlined hint="Adresse"
                                persistent-hint
                                prepend-inner-icon="mdi-home-city"/>
                </v-col>
                <v-col sm="12" md="12" lg="4" xl="4" cols="12">
                  <v-text-field v-model="company.iban" solo dense outlined hint="IBAN" persistent-hint
                                prepend-inner-icon="mdi-credit-card-outline"/>
                </v-col>
                <v-col sm="12" md="12" lg="4" xl="4" cols="12">
                  <v-text-field v-model="company.propertyStatus" solo dense outlined
                                hint="Zustand des Gebäude" persistent-hint
                                prepend-inner-icon="mdi-glass-fragile"/>
                </v-col>
                <v-col sm="12" md="12" lg="12" xl="12" cols="12">
                  <v-card elevation="2" outlined>
                    <v-list nav dense>
                      <v-autocomplete v-model="company.owner" :items="criminals" return-object
                                      item-text="name" clearable
                                      solo dense outlined hint="Besitzer" persistent-hint
                                      prepend-inner-icon="mdi-account"/>
                      <v-divider class="pb-2 mt-2"/>
                      <v-list-item @click="test"
                                   v-for="(v, k) in company.authorizedRepresentatives" :key="k">
                        <v-list-item-icon>
                          <v-icon>mdi-account-tag-outline</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                          <v-list-item-title v-text="v.name"></v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-btn x-small color="error" @click="removeRepresentative(v)">
                            <v-icon left small>mdi-delete-empty-outline</v-icon>
                            Löschen
                          </v-btn>
                        </v-list-item-action>
                      </v-list-item>
                      <v-list-item v-if="company.authorizedRepresentatives.length === 0">
                        <v-list-item-content>
                          <i>Kein Vertreter</i>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                    <v-divider/>
                    <v-card-actions>
                      <v-btn small color="primary" @click="addRepresentativeModal = true;">
                        <v-icon left>mdi-account-plus</v-icon>
                        Neuen Vertreter Hinzufügen
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="warning" small :loading="saving" :disabled="dirtyFields.length === 0"
                 @click="updateCompany()">
            Speichern
          </v-btn>
        </v-card-actions>
        <v-divider/>
        <v-tabs color="warning" v-model="tabIndex">
          <v-tab>Einträge</v-tab>
          <v-tab>Strikes</v-tab>
          <v-tab>Access Tokens</v-tab>
          <v-tab>Kosten</v-tab>
          <v-tab>Kontrollen</v-tab>
        </v-tabs>
        <v-divider/>
        <v-card-text v-if="tabIndex === 0">
          <v-row v-for="entry in company.entries" :key="entry.id">
            <v-col class="pa-0">
              <company-record-entry v-on:updated="fetchCompany" :company="company"
                                    :entry="entry"/>
            </v-col>
          </v-row>
        </v-card-text>
        <div v-if="tabIndex === 1">
          <v-data-table :items="strikeDataTable" sort-by="createdAt" sort-desc
                        :headers="[{text: 'Erstellt am', value: 'createdAt'}, {text: 'Läuft aus', value: 'expiresAfter'}, {text: 'Beschreibung', value: 'name'}, {text: 'Bußgeld', value: 'fine'}, {text: 'Punkte', value: 'points'}, {text: 'Ersteller', value: 'createdByName'}, {text: 'CR-Status', value: 'criminalRecordStatus', sortable: false}, {text: 'Aktionen', value: 'actions'}]">
            <template v-slot:item.createdAt="{ item }">
              <div v-if="item.revokedAt">
                                <span style="text-decoration-line: line-through">{{
                                    visualizeDate(item.createdAt)
                                  }}</span>
                ({{ visualizeDate(item.revokedAt) }})
              </div>
              <div v-else>
                {{ visualizeDate(item.createdAt) }}
              </div>
            </template>

            <template v-slot:item.expiresAfter="{ item }">
              {{ visualizeDate(item.expiresAfter) }}
            </template>

            <template v-slot:item.actions="{ item }">
              <v-btn x-small v-if="!item.revoked && !isStrikeExpired(item)" @click="revokeStrike(item)"
                     color="error" class="pr-2">
                <v-icon left>mdi-delete</v-icon>
                Zurückziehen
              </v-btn>

              <v-chip color="primary" small class="elevation-3 pr-2" v-if="isStrikeExpired(item)">Ausgelaufen</v-chip>
              <v-chip color="warning" small class="elevation-3 pr-2" v-if="item.revoked">Zurückgezogen</v-chip>
            </template>

            <template v-slot:item.criminalRecordStatus="{ item }">
              <template v-if="item.criminalRecordEntryId">
                <v-chip small color="success" class="elevation-2" v-if="criminalRecordEntryStatuses[item.criminalRecordEntryId] && criminalRecordEntryStatuses[item.criminalRecordEntryId].enforced">
                  <v-icon left x-small>mdi-check-circle</v-icon>
                  Durchgesetzt
                </v-chip>
                <v-chip small color="warning" class="elevation-2" v-else-if="criminalRecordEntryStatuses[item.criminalRecordEntryId] !== undefined">
                  <v-icon left x-small>mdi-clock-outline</v-icon>
                  Ausstehend
                </v-chip>
                <v-chip small color="grey" class="elevation-2" v-else>
                  <v-icon left x-small>mdi-dots-horizontal</v-icon>
                  Lädt...
                </v-chip>
              </template>
            </template>
          </v-data-table>
          <v-divider/>
          <v-card-actions>
            <v-btn small color="error" @click="openCreateStrikeDialog()">
              <v-icon left>mdi-exclamation-thick</v-icon>
              Strike erfassen
            </v-btn>
          </v-card-actions>
        </div>
        <div v-if="tabIndex === 2">
          <v-data-table :items="company.accessTokens" :headers="accessTokenHeaders">
            <template v-slot:item.actions="{ item }">
              <v-btn small icon color="error" @click="revokeAccessToken(item.id)">
                <v-icon>mdi-delete-variant</v-icon>
              </v-btn>
              <v-btn small icon color="primary" :to="'/_public/business/' + item.token" target="_blank">
                <v-icon>mdi-eye-outline</v-icon>
              </v-btn>
            </template>
          </v-data-table>
          <v-divider/>
          <v-card-actions>
            <v-btn small color="primary" @click="createAccessToken()">Zugriffstoken erstellen</v-btn>
          </v-card-actions>
        </div>
        <div v-if="tabIndex === 3">
          <v-data-table
            :items="company.licenseLinks"
            :headers="licenseHeaders"
            hide-default-footer>
            <template v-slot:item.name="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on" class="license-name-tooltip-anchor">{{ item.license.name }}</span>
                </template>
                <span class="license-description-tooltip-content">{{ displayLicenseDescription(item) }}</span>
              </v-tooltip>
            </template>
            <template v-slot:item.fee="{ item }">
              {{ formatMoney((Number(item.license.fee) || 0)) }}
            </template>
            <template v-slot:item.count="{ item }">
              {{ Number(item.count) || 1 }}
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn x-small color="primary" class="mr-2" :disabled="saving || editLicenseSaving" @click="openLicensePriceDialog(item)">
                <v-icon left small>mdi-pencil</v-icon>
                Bearbeiten
              </v-btn>
              <v-btn x-small color="error" :disabled="saving || editLicenseSaving" @click="removeLicense(item)">
                <v-icon left small>mdi-delete</v-icon>
                Löschen
              </v-btn>
            </template>
          </v-data-table>

          <v-divider/>

          <div class="text-right pa-2 pr-5">
            Lizenzen (pro Woche): <b>{{ formatMoney(totalLicenseFees) }}</b>
            <br>
            Werbeschilder (pro Woche): <b>{{ formatMoney(totalSignFees) }}</b>
            <br>
            Gesamt (pro Woche): <b>{{ formatMoney(totalCommercialFees) }}</b>
          </div>

          <v-divider/>

          <v-card-text>
            <v-row>
              <v-col cols="12" md="6">
                <v-select
                  v-model="selectedLicenseTemplate"
                  :items="selectableLicenses"
                  item-text="name"
                  return-object
                  @change="onLicenseTemplateChanged"
                  hint="Kostenpunkt auswählen"
                  persistent-hint
                  prepend-inner-icon="mdi-license"
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model.number="newLicensePrice"
                  type="number"
                  min="0"
                  step="1"
                  readonly
                  hint="Preis"
                  persistent-hint
                  prepend-inner-icon="mdi-currency-eur"
                />
              </v-col>
              <v-col cols="12" md="3" class="d-flex align-center">
                <v-btn block color="primary" :loading="saving" @click="addLicense()" :disabled="!selectedLicenseTemplate || saving || editLicenseSaving">
                  <v-icon left>mdi-plus</v-icon>
                  Kostenpunkt hinzufügen
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider/>

          <v-card-subtitle class="pb-0">Werbeschilder</v-card-subtitle>

          <v-data-table
            :items="company.signLinks"
            :headers="signHeaders"
            hide-default-footer>
            <template v-slot:item.signIid="{ item }">
              {{ item.sign?.iid ?? '-' }}
            </template>
            <template v-slot:item.postalCode="{ item }">
              {{ item.sign?.postalCode || '-' }}
            </template>
            <template v-slot:item.linkedSigns="{ item }">
              <div v-if="item.sign?.linkedSigns && item.sign.linkedSigns.length > 0" class="d-flex flex-wrap ga-1">
                <v-chip
                  v-for="linkedSign in item.sign.linkedSigns"
                  :key="linkedSign.id"
                  x-small
                  outlined
                  color="primary"
                  class="mr-1 mb-1"
                >
                  {{ formatSignLabel(linkedSign) }}
                </v-chip>
              </div>
              <span v-else>-</span>
            </template>
            <template v-slot:item.picture="{ item }">
              <v-menu
                v-if="item.sign?.picture && item.sign.picture.id"
                open-on-hover
                offset-y
                bottom
                nudge-right="12"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-avatar
                    size="42"
                    tile
                    class="sign-preview-activator"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-img :src="apiAttachmentUrl(item.sign.picture)"/>
                  </v-avatar>
                </template>
                <v-card class="pa-2">
                  <v-img
                    :src="apiAttachmentUrl(item.sign.picture)"
                    max-width="320"
                    max-height="320"
                    contain
                  />
                </v-card>
              </v-menu>
              <span v-else>-</span>
            </template>
            <template v-slot:item.fee="{ item }">
              {{ formatMoney((Number(item.sign?.fee) || 0)) }}
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn x-small color="error" :disabled="saving || editLicenseSaving" @click="removeSign(item)">
                <v-icon left small>mdi-delete</v-icon>
                Entfernen
              </v-btn>
            </template>
          </v-data-table>

          <v-divider/>

          <v-card-text>
            <v-row>
              <v-col cols="12" md="9">
                <v-select
                  v-model="selectedSignTemplate"
                  :items="selectableSigns"
                  item-text="displayName"
                  return-object
                  hint="Werbeschild auswählen"
                  persistent-hint
                  prepend-inner-icon="mdi-billboard"
                />
              </v-col>
              <v-col cols="12" md="3" class="d-flex align-center">
                <v-btn block color="primary" :loading="saving" @click="addSign()" :disabled="!selectedSignTemplate || saving || editLicenseSaving">
                  <v-icon left>mdi-plus</v-icon>
                  Schild zuweisen
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </div>
        <div v-if="tabIndex === 4">
          <v-data-table
            :items="inspectionDataTable"
            sort-by="createdAt"
            sort-desc
            :headers="[
              {text: 'Datum', value: 'createdAt'},
              {text: 'Nächste Kontrolle', value: 'nextInspectionAt'},
              {text: 'Notiz', value: 'note'},
              {text: 'Nachkontrolle', value: 'followUpLabel'},
              {text: 'Beweise', value: 'evidenceLinks', sortable: false},
              {text: 'Ersteller', value: 'createdByName'},
              {text: 'Aktionen', value: 'actions', sortable: false},
            ]">
            <template v-slot:item.createdAt="{ item }">
              {{ visualizeDate(item.createdAt) }}
            </template>
            <template v-slot:item.nextInspectionAt="{ item }">
              {{ visualizeDateOnly(item.nextInspectionAt) }}
            </template>
            <template v-slot:item.evidenceLinks="{ item }">
              <div v-if="item.evidenceLinks && item.evidenceLinks.length > 0">
                <a
                  v-for="(url, idx) in item.evidenceLinks"
                  :key="idx"
                  :href="url"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="mr-2"
                >
                  Beweis {{ idx + 1 }}
                </a>
              </div>
              <span v-else>-</span>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn x-small color="error" @click="deleteInspection(item)">
                <v-icon left>mdi-delete</v-icon>
                Löschen
              </v-btn>
            </template>
          </v-data-table>
          <v-divider/>
          <v-card-actions>
            <v-btn small color="primary" @click="openCreateInspectionDialog()">
              <v-icon left>mdi-clipboard-check-outline</v-icon>
              Kontrolle erfassen
            </v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </v-container>

    <v-dialog v-model="addRepresentativeModal" @close="addRepresentativeModal=false;" width="500">
      <v-card>
        <v-card-title class="pb-2 pt-2">
          <v-icon left>mdi-account-plus</v-icon>
          Vertreter hinzufügen
        </v-card-title>
        <v-divider/>
        <v-card-text class="pb-0 mt-4">
          <v-autocomplete v-model="addRepresentativeRecord" :items="criminals" return-object
                          item-text="name" clearable
                          solo dense outlined hint="Vertreter" persistent-hint
                          prepend-inner-icon="mdi-account"/>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-btn color="primary" small @click="addRepresentative()">
            <v-icon left>mdi-content-save</v-icon>
            Hinzufügen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editLicenseModal" max-width="500" persistent>
      <v-card>
        <v-card-title class="pb-2 pt-2">
          <v-icon left>mdi-license</v-icon>
          Kostenpunkt bearbeiten
        </v-card-title>
        <v-divider/>
        <v-card-text class="pt-4">
          <v-text-field
            :value="editLicenseName"
            dense
            outlined
            hint="Kostenpunkt"
            persistent-hint
            readonly
            prepend-inner-icon="mdi-format-title"
          />
          <v-textarea
            :value="editLicenseDescription"
            dense
            outlined
            rows="2"
            hint="Beschreibung"
            persistent-hint
            readonly
            prepend-inner-icon="mdi-text"
          />
          <v-text-field
            :value="formatMoney(editLicensePrice)"
            dense
            outlined
            hint="Preis (Kostenpunktstammdaten)"
            persistent-hint
            readonly
            prepend-inner-icon="mdi-currency-eur"
          />
          <v-text-field
            v-model.number="editLicenseCount"
            type="number"
            min="1"
            step="1"
            dense
            outlined
            hint="Anzahl"
            persistent-hint
            prepend-inner-icon="mdi-counter"
          />
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-btn small color="success" :loading="editLicenseSaving" :disabled="editLicenseSaving" @click="saveEditedLicensePrice()">
            <v-icon left>mdi-content-save</v-icon>
            Übernehmen
          </v-btn>
          <v-spacer/>
          <v-btn small color="grey" :disabled="editLicenseSaving" @click="closeLicensePriceDialog()">
            Abbrechen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="createStrikeModal" max-width="750" persistent>
      <v-card>
        <v-card-title class="pb-2 pt-2">
          <v-icon left>mdi-exclamation-thick</v-icon>
          Strike erfassen
        </v-card-title>
        <v-divider/>
        <v-card-text class="pt-4">
          <v-autocomplete
            v-model="createStrikeForm.fineRecord"
            :items="fineRecords"
            return-object
            :item-text="formatFineRecordLabel"
            clearable
            dense
            outlined
            hint="Paragraph aus dem Bußgeld-Rechner"
            persistent-hint
            prepend-inner-icon="mdi-calculator"
            @change="onStrikeFineRecordChanged"
          />
          <v-alert
            v-if="createStrikeForm.fineRecord && !strikeFineRecordHasConfiguredPoints"
            dense
            outlined
            type="warning"
            class="mt-2"
          >
            Für den gewählten Paragraphen ist keine explizite Strike-Anzahl hinterlegt. Bitte Strikes prüfen.
          </v-alert>
          <v-text-field
            v-model="createStrikeForm.paragraph"
            dense
            outlined
            readonly
            hint="Paragraph"
            persistent-hint
            prepend-inner-icon="mdi-section"
          />
          <v-text-field
            v-model="createStrikeForm.name"
            dense
            outlined
            hint="Beschreibung"
            persistent-hint
            prepend-inner-icon="mdi-text-box-outline"
          />
          <v-text-field
            v-model.number="createStrikeForm.fine"
            type="number"
            min="0"
            step="1"
            dense
            outlined
            hint="Bußgeld"
            persistent-hint
            prepend-inner-icon="mdi-currency-eur"
          />
          <v-text-field
            v-model.number="createStrikeForm.points"
            type="number"
            min="0"
            step="1"
            dense
            outlined
            hint="Strikes"
            persistent-hint
            prepend-inner-icon="mdi-counter"
          />
          <v-checkbox
            v-model="createStrikeForm.createCriminalRecord"
            dense
            hide-details
            label="Zusätzlich Criminal Record für Inhaber erstellen"
          />
          <v-checkbox
            v-model="createStrikeForm.createCriminalRecordWanted"
            dense
            hide-details
            :disabled="!createStrikeForm.createCriminalRecord"
            label="Inhaber zur Fahndung ausschreiben"
          />
          <v-text-field
            :value="company?.owner?.name || ''"
            dense
            outlined
            readonly
            hint="Inhaber (Record-Ziel)"
            persistent-hint
            prepend-inner-icon="mdi-account"
          />
          <v-text-field
            v-model="createStrikeForm.zipCode"
            dense
            outlined
            type="number"
            clearable
            hint="Ort des Verbrechens (PLZ) – wird in Record übernommen"
            persistent-hint
            prepend-inner-icon="mdi-home-city"
          />

          <template v-if="createStrikeForm.createCriminalRecord">
            <v-divider class="my-3"/>
            <div class="caption grey--text mb-1">Optionale Angaben zum Criminal Record</div>

            <v-select
              :items="strikeIllegalItems"
              v-model="createStrikeIllegalItemsSelected"
              item-value="item"
              dense
              outlined
              hint="Besitz illegaler Gegenstände"
              persistent-hint
              return-object
              multiple
              clearable
              prepend-inner-icon="mdi-bag-personal"
              class="mt-1"
            >
              <template v-slot:selection="{ item }">
                <div class="pr-4">
                  <img height="16px" :src='"https://fivem.r3ktm8.de/items/" + item.item + ".png"'/>
                  <span class="pl-3">{{ item.label }}</span>
                </div>
              </template>
              <template v-slot:item="{ item }">
                <img height="24px" :src='"https://fivem.r3ktm8.de/items/" + item.item + ".png"'/>
                <span class="pl-3">{{ item.label }}</span>
              </template>
            </v-select>

            <v-text-field
              v-model="createStrikeEvidenceInput"
              dense
              outlined
              clearable
              clear-icon="mdi-delete"
              prepend-inner-icon="mdi-archive"
              hint="Beweismaterial aus dem Zwischenspeicher hier einfügen oder Bild-URL eingeben"
              persistent-hint
              placeholder="Beweismaterial einfügen oder URL eingeben"
              :readonly="createStrikeEvidenceLock"
              @paste.prevent="onStrikeEvidencePaste"
              @change="onStrikeEvidenceUrlInput"
              @click:clear="createStrikeEvidenceInput = null"
              class="mt-1"
            />

            <v-row v-if="createStrikeEvidences.length > 0" class="mt-1 mx-0">
              <v-col cols="4" v-for="(ev, k) in createStrikeEvidences" :key="k" class="pa-1">
                <div v-if="ev.type === 'BASE64_IMAGE'" class="evidence-thumb">
                  <v-img @click="createStrikeEvidences.splice(k, 1)" :height="256/16*9" :width="256"
                         :src="'data:image/png;base64,' + ev.image" style="cursor:pointer"/>
                </div>
                <div v-else-if="ev.type === 'URL'" class="evidence-thumb">
                  <v-img @click="createStrikeEvidences.splice(k, 1)" :height="256/16*9" :width="256"
                         :src="ev.image" style="cursor:pointer"/>
                </div>
              </v-col>
            </v-row>
          </template>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-btn small color="success" :loading="saving" @click="createStrike()">
            <v-icon left>mdi-content-save</v-icon>
            Erstellen
          </v-btn>
          <v-spacer/>
          <v-btn small color="grey" @click="closeCreateStrikeDialog()">
            Abbrechen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="createInspectionModal" max-width="600" persistent>
      <v-card>
        <v-card-title class="pb-2 pt-2">
          <v-icon left>mdi-clipboard-check-outline</v-icon>
          Gewerbekontrolle erfassen
        </v-card-title>
        <v-divider/>
        <v-card-text class="pt-4">
          <v-textarea
            v-model="createInspectionForm.note"
            dense
            outlined
            rows="3"
            hint="Notiz / Bemerkungen"
            persistent-hint
            prepend-inner-icon="mdi-text-box-outline"
          />
          <v-checkbox
            v-model="createInspectionForm.followUp"
            dense
            hide-details
            label="Nachkontrolle"
            class="mb-2"
          />
          <v-text-field
            v-if="createInspectionForm.followUp"
            v-model.number="createInspectionForm.followUpDays"
            type="number"
            min="1"
            step="1"
            dense
            outlined
            hint="Nachkontrolle in X Tagen"
            persistent-hint
            prepend-inner-icon="mdi-calendar-clock"
          />
          <v-divider class="my-3"/>
          <v-text-field
            v-model="createInspectionEvidenceInput"
            dense
            outlined
            clearable
            clear-icon="mdi-delete"
            prepend-inner-icon="mdi-archive"
            hint="Beweismaterial aus dem Zwischenspeicher hier einfügen oder Bild-URL eingeben"
            persistent-hint
            placeholder="Beweismaterial einfügen oder URL eingeben"
            @paste.prevent="onInspectionEvidencePaste"
            @change="onInspectionEvidenceUrlInput"
            @click:clear="createInspectionEvidenceInput = null"
            class="mt-1"
          />
          <v-row v-if="createInspectionEvidences.length > 0" class="mt-1 mx-0">
            <v-col cols="4" v-for="(ev, k) in createInspectionEvidences" :key="k" class="pa-1">
              <div v-if="ev.type === 'BASE64_IMAGE'" class="evidence-thumb">
                <v-img @click="createInspectionEvidences.splice(k, 1)" :height="256/16*9" :width="256"
                       :src="'data:image/png;base64,' + ev.image" style="cursor:pointer"/>
              </div>
              <div v-else-if="ev.type === 'URL'" class="evidence-thumb">
                <v-img @click="createInspectionEvidences.splice(k, 1)" :height="256/16*9" :width="256"
                       :src="ev.image" style="cursor:pointer"/>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-btn small color="success" :loading="saving" @click="createInspection()">
            <v-icon left>mdi-content-save</v-icon>
            Erstellen
          </v-btn>
          <v-spacer/>
          <v-btn small color="grey" @click="closeCreateInspectionDialog()">
            Abbrechen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<style>
.company-file-image-background {
  background-color: #838486;
  border-radius: 15px;
  transform: rotate(-3deg);
}

.sign-preview-activator {
  cursor: zoom-in;
}

.license-name-tooltip-anchor {
  cursor: help;
}

.license-description-tooltip-content {
  white-space: pre-line;
}
</style>

<!--suppress EqualityComparisonWithCoercionJS -->
<script>

import moment from "moment";
import CustomDatePicker from "@/components/CustomDatePicker.vue";
import CompanyRecordEntry from "@/components/CompanyRecordEntry.vue";
import {COMPANY_TYPES} from "../../plugins/config";
import Swal from 'sweetalert2';

export default {
  components: {CompanyRecordEntry, CustomDatePicker},
  data: () => ({
    companyId: null,
    company: null,
    companyUnmodified: null,
    saving: false,

    tabIndex: 1,

    dirtyFields: [],

    addRepresentativeModal: false,
    addRepresentativeRecord: null,

    accessTokenHeaders: [
      {text: 'ID', value: 'id'},
      {text: 'Token', value: 'token'},
      {text: 'Ersteller', value: 'createdBy.displayName'},
      {text: 'Aktionen', value: 'actions'},
    ],

    licenseHeaders: [
      {text: 'Kostenpunkt', value: 'name'},
      {text: 'Preis', value: 'fee'},
      {text: 'Anzahl', value: 'count'},
      {text: 'Aktionen', value: 'actions'},
    ],

    signHeaders: [
      {text: 'Schild-ID', value: 'signIid'},
      {text: 'PLZ/Straße', value: 'postalCode'},
      {text: 'Verknüpfte Schilder', value: 'linkedSigns', sortable: false},
      {text: 'Bild', value: 'picture', sortable: false},
      {text: 'Gebühr', value: 'fee'},
      {text: 'Aktionen', value: 'actions', sortable: false},
    ],

    selectedLicenseTemplate: null,
    newLicensePrice: 0,
    selectedSignTemplate: null,

    editLicenseModal: false,
    editLicenseLink: null,
    editLicensePrice: 0,
    editLicenseCount: 1,
    editLicenseOriginalCount: 1,
    editLicenseSaving: false,

    createStrikeModal: false,
    createStrikeForm: {
      name: '',
      fine: 0,
      points: 1,
      paragraph: '',
      fineRecord: null,
      zipCode: null,
      createCriminalRecord: false,
      createCriminalRecordWanted: true,
    },
    createStrikeIllegalItemsSelected: [],
    createStrikeEvidences: [],
    createStrikeEvidenceInput: null,
    createStrikeEvidenceLock: false,
    criminalRecordEntryStatuses: {},
    createInspectionModal: false,
    createInspectionForm: {
      note: '',
      followUp: false,
      followUpDays: 7,
    },
    createInspectionEvidences: [],
    createInspectionEvidenceInput: null,
    strikeIllegalItems: [
      {paragraph: '§2 Abs. 3c StGB', item: 'WEAPON_ASSAULTRIFLE', label: 'Kampfgewehr'},
      {paragraph: '§2 Abs. 3c StGB', item: 'WEAPON_ASSAULTRIFLE_MK2', label: 'Kampfgewehr Mk.2'},
      {paragraph: '§2 Abs. 3c StGB', item: 'WEAPON_MICROSMG', label: 'Mikro-SMG'},
      {paragraph: '§2 Abs. 3c StGB', item: 'WEAPON_ASSAULTSMG', label: 'Kampf-SMG'},
      {paragraph: '§2 Abs. 3c StGB', item: 'WEAPON_BULLPUPRIFLE', label: 'Bullpupgewehr'},
      {paragraph: '§2 Abs. 3c StGB', item: 'WEAPON_COMPACTRIFLE', label: 'Kurzes Kampfgewehr'},
      {paragraph: '§2 Abs. 3b StGB', item: 'WEAPON_PISTOL', label: 'Pistole'},
      {paragraph: '§2 Abs. 3b StGB', item: 'WEAPON_PISTOL50', label: 'Pistole .50'},
      {paragraph: '§2 Abs. 3b StGB', item: 'WEAPON_DOUBLEACTION', label: 'Double-Action Revolver'},
      {paragraph: '§2 Abs. 3b StGB', item: 'WEAPON_REVOLVER', label: 'Revolver'},
      {paragraph: '§1 Abs. 7 StGB', item: 'laptop_h', label: 'Hacker-Laptop'},
      {paragraph: '§1 Abs. 7 StGB', item: 'id_card', label: 'Kodierte Schlüsselkarte'},
      {paragraph: '§1 Abs. 7 StGB', item: 'secure_card', label: 'Sicherheitskarte'},
      {paragraph: '§1 Abs. 7 StGB', item: 'lockpick', label: 'Dietrich'},
      {paragraph: '§1 Abs. 7 StGB', item: 'fakeplate', label: 'Fake Kennzeichen'},
      {paragraph: '§1 Abs. 1c BtMG', item: 'cocaine', label: 'Kokain'},
      {paragraph: '§1 Abs. 1c BtMG', item: 'tilidin', label: 'Tilidin'},
      {paragraph: '§1 Abs. 1c BtMG', item: 'heroin', label: 'Heroin'},
      {paragraph: '§1 Abs. 1c BtMG', item: 'joint', label: 'Joint'},
      {paragraph: '§1 Abs. 1a BtMG', item: 'weed', label: 'Weed'},
      {paragraph: '§1 Abs. 1a BtMG', item: 'croton_oil', label: 'Croton-Öl'},
      {paragraph: '§1 Abs. 1a BtMG', item: 'opium_poppy', label: 'Schlafmohn'},
      {paragraph: '§1 Abs. 1a BtMG', item: 'coca_leafe', label: 'Kokain-Blätter'},
    ],

    availableLicenses: [],
    availableSigns: [],
    fineRecords: [],

    criminals: [],
  }),
  computed: {
    selectableLicenses() {
      const source = Array.isArray(this.availableLicenses) ? this.availableLicenses : [];
      const existingLinks = Array.isArray(this.company?.licenseLinks) ? this.company.licenseLinks : [];

      const existingLicenseIds = new Set(
        existingLinks
          .map(link => link?.license?.id)
          .filter(Boolean)
      );

      return source.filter(license => !existingLicenseIds.has(license.id));
    },
    selectableSigns() {
      const source = Array.isArray(this.availableSigns) ? this.availableSigns : [];
      const existingLinks = Array.isArray(this.company?.signLinks) ? this.company.signLinks : [];

      const existingSignIds = new Set(
        existingLinks
          .map(link => link?.sign?.id)
          .filter(Boolean)
      );

      return source
        .filter(sign => !existingSignIds.has(sign.id))
        .map(sign => ({
          ...sign,
          displayName: `#${sign.iid ?? '-'} - PLZ ${sign.postalCode || '-'} - ${this.formatMoney(sign.fee)}`,
        }));
    },
    totalLicenseFees() {
      if (!this.company || !Array.isArray(this.company.licenseLinks)) return 0;

      let total = 0;
      for (const link of this.company.licenseLinks) {
        total += (Number(link.license?.fee) || 0) * (Number(link.count) || 1);
      }

      return total;
    },
    totalSignFees() {
      if (!this.company || !Array.isArray(this.company.signLinks)) return 0;

      let total = 0;
      for (const link of this.company.signLinks) {
        total += Number(link?.sign?.fee) || 0;
      }

      return total;
    },
    totalCommercialFees() {
      return this.totalLicenseFees + this.totalSignFees;
    },
    editLicenseName() {
      return this.resolveLicenseName(this.editLicenseLink) || this.editLicenseLink?.license?.name || '';
    },
    editLicenseDescription() {
      return this.resolveLicenseDescription(this.editLicenseLink) || 'Keine Beschreibung hinterlegt';
    },
    strikeFineRecordHasConfiguredPoints() {
      if (!this.createStrikeForm?.fineRecord) return true;
      return this.resolveFineRecordStrikePoints(this.createStrikeForm.fineRecord) !== null;
    },
    strikeDataTable() {
      let result = [];

      const strikes = Array.isArray(this.company?.strikes) ? this.company.strikes : [];
      for (const strike of strikes) {
        result.push({
          id: strike.id,
          name: strike.name,
          fine: strike.fine,
          points: strike.points,
          createdByName: strike.createdBy.displayName,
          revokedByName: strike.revokedBy?.displayName,
          createdAt: moment(strike.createdAt).unix(),
          revokedAt: strike.revokedAt ? moment(strike.revokedAt).unix() : null,
          expiresAfter: moment(strike.expiresAfter).unix(),
          revoked: strike.revoked === null ? false : strike.revoked,
          payed: strike.payed === null ? false : strike.payed,
          criminalRecordEntryId: strike.criminalRecordEntryId || null,
        });
      }

      return result;
    },
    nextInspectionDateComputed() {
      const inspections = Array.isArray(this.company?.inspections) ? this.company.inspections : [];
      if (inspections.length === 0) return null;
      const latest = inspections.reduce((prev, cur) => {
        return moment(cur.createdAt).isAfter(moment(prev.createdAt)) ? cur : prev;
      });
      return latest.nextInspectionAt ? moment(latest.nextInspectionAt).unix() : null;
    },
    isNextInspectionOverdue() {
      if (!this.nextInspectionDateComputed) return false;
      return moment.unix(this.nextInspectionDateComputed).isBefore(moment());
    },
    inspectionDataTable() {
      const inspections = Array.isArray(this.company?.inspections) ? this.company.inspections : [];
      return inspections.map(inspection => {
        const attachmentIds = Array.isArray(inspection.evidenceAttachmentIds) ? inspection.evidenceAttachmentIds : [];
        return {
          id: inspection.id,
          note: inspection.note || '',
          createdAt: inspection.createdAt ? moment(inspection.createdAt).unix() : null,
          nextInspectionAt: inspection.nextInspectionAt ? moment(inspection.nextInspectionAt).unix() : null,
          followUpLabel: inspection.followUp ? `Ja (${Number(inspection.followUpDays) || 7} Tage)` : 'Nein',
          createdByName: inspection.createdBy?.displayName || '-',
          evidenceLinks: attachmentIds.map(id => this.apiAttachmentUrl({id})),
        };
      });
    },

    companyTypes() {
      let obj = [];

      for (let typeName in COMPANY_TYPES) {
        obj.push({type: typeName, label: COMPANY_TYPES[typeName]})
      }
      return obj;
    }
  },
  methods: {
    normalizeLinkedSigns(linkedSigns) {
      const source = Array.isArray(linkedSigns) ? linkedSigns : [];
      const dedupe = new Map();

      for (const linkedSign of source) {
        if (!linkedSign?.id) continue;
        dedupe.set(linkedSign.id, {
          id: linkedSign.id,
          iid: Number(linkedSign.iid) || 0,
          postalCode: linkedSign.postalCode || '',
          fee: Math.max(0, Number(linkedSign.fee) || 0),
          picture: linkedSign.picture || null,
        });
      }

      return Array.from(dedupe.values()).sort((a, b) => (a.iid || 0) - (b.iid || 0));
    },
    normalizeSign(sign) {
      return {
        id: sign?.id || null,
        iid: Number(sign?.iid) || 0,
        postalCode: sign?.postalCode || '',
        fee: Math.max(0, Number(sign?.fee) || 0),
        picture: sign?.picture || null,
        linkedSigns: this.normalizeLinkedSigns(sign?.linkedSigns),
      };
    },
    formatSignLabel(sign) {
      if (!sign) return '-';

      const parts = [`#${sign.iid ?? '-'}`];
      if (sign.postalCode) {
        parts.push(`PLZ ${sign.postalCode}`);
      }

      return parts.join(' - ');
    },
    createAccessToken() {
      this.apiCompanyCreateAccessToken(this.company.id).then(() => this.fetchCompany())
    },
    revokeAccessToken(id) {
      this.apiCompanyRevokeAccessToken(this.company.id, id).then(() => this.fetchCompany())
    },
    isStrikeExpired(strike) {
      let expiresAfter = moment.unix(strike.expiresAfter);
      let now = moment();
      return now.isAfter(expiresAfter)
    },
    visualizeDate(timestamp) {
      return timestamp ? moment.unix(timestamp).format('DD.MM.YYYY HH:mm') : 'N/A';
    },
    visualizeDateOnly(timestamp) {
      return timestamp ? moment.unix(timestamp).format('DD.MM.YYYY') : 'N/A';
    },
    test() {
    },
    revokeStrike(strike) {
      this.apiCompanyRevokeStrike(this.company.id, strike.id).then(() => {
        this.fetchCompany();
      })
    },
    formatFineRecordLabel(record) {
      if (!record) return '';
      const paragraph = `${record.paragraph || ''}`.trim();
      const description = `${record.description || ''}`.trim();

      if (paragraph && description) return `${paragraph} - ${description}`;
      if (paragraph) return paragraph;
      if (description) return description;
      return 'Unbekannter Paragraph';
    },
    resolveFineRecordStrikePoints(record) {
      if (!record || typeof record !== 'object') return null;

      const candidates = [
        record.strikePoints,
        record.companyStrikePoints,
        record.points,
        record.penaltyPoints,
      ];

      for (const candidate of candidates) {
        if (candidate === null || candidate === undefined || candidate === '') continue;
        const numeric = Number(candidate);
        if (!Number.isNaN(numeric)) {
          return Math.max(0, numeric);
        }
      }

      return null;
    },
    onStrikeFineRecordChanged(record) {
      if (!record) {
        this.createStrikeForm.paragraph = '';
        return;
      }

      this.createStrikeForm.paragraph = `${record.paragraph || ''}`.trim();

      const description = `${record.description || ''}`.trim();
      const paragraph = `${record.paragraph || ''}`.trim();
      this.createStrikeForm.name = description && paragraph ? `${paragraph} ${description}` : (description || paragraph || this.createStrikeForm.name);

      if (record.fine !== undefined && record.fine !== null && record.fine !== '') {
        this.createStrikeForm.fine = Math.max(0, Number(record.fine) || 0);
      }

      const strikePoints = this.resolveFineRecordStrikePoints(record);
      if (strikePoints !== null) {
        this.createStrikeForm.points = strikePoints;
      }
    },
    resetCreateStrikeForm() {
      this.createStrikeForm = {
        name: '',
        fine: 0,
        points: 1,
        paragraph: '',
        fineRecord: null,
        zipCode: null,
        createCriminalRecord: false,
        createCriminalRecordWanted: true,
      };
      this.createStrikeIllegalItemsSelected = [];
      this.createStrikeEvidences = [];
      this.createStrikeEvidenceInput = null;
      this.createStrikeEvidenceLock = false;
    },
    createStrikePayloadFromForm() {
      return {
        name: (this.createStrikeForm.name || '').trim(),
        fine: Math.max(0, Number(this.createStrikeForm.fine) || 0),
        points: Math.max(0, Number(this.createStrikeForm.points) || 0),
        delivered: false,
        criminalRecordEntryId: null,
      };
    },
    async fetchCriminalRecordEntryStatuses() {
      const strikes = Array.isArray(this.company?.strikes) ? this.company.strikes : [];
      const entryIds = strikes.map(s => s.criminalRecordEntryId).filter(id => !!id);
      if (entryIds.length === 0) return;
      const statuses = {};
      await Promise.all(entryIds.map(async (entryId) => {
        try {
          const r = await this.apiGetCriminalRecordEntry(entryId);
          statuses[entryId] = r.data;
        } catch (e) {
          statuses[entryId] = null;
        }
      }));
      this.criminalRecordEntryStatuses = { ...this.criminalRecordEntryStatuses, ...statuses };
    },
    buildOwnerRecordPayload(strikePayload, evidenceUrlList = []) {
      const ownerName = this.company?.owner?.name || 'Unbekannt';
      const companyName = this.company?.name || 'Unbekanntes Gewerbe';
      const companyAddress = this.company?.location || 'Unbekannte Adresse';
      const description = strikePayload?.name || 'Verstoß gegen Gewerbeauflagen';


      let content = `**Gewertete Einträge**:\n+ ${description}\n\nGewerbe: **${companyName}**\nInhaber: **${ownerName}**\nAdresse: **${companyAddress}**`;

      if (this.createStrikeIllegalItemsSelected.length > 0) {
        content += '\n\n**Beschlagnahmte Gegenstände**:\n';
        for (const it of this.createStrikeIllegalItemsSelected) {
          content += `- ${it.label}\n`;
        }
      }

      if (evidenceUrlList.length > 0) {
        content += `\n\n**Beweise**:\n${evidenceUrlList.join('\n')}\n`;
      }

      return {
        type: 'TICKET',
        content,
        context: `Automatisch aus Strike im Gewerbe ${companyName} erzeugt. Adresse: ${companyAddress}`,
        fine: strikePayload.fine,
        jailTime: 0,
        penaltyPoints: null,
        wanted: Boolean(this.createStrikeForm.createCriminalRecordWanted),
        zipCode: this.createStrikeForm.zipCode ? Number(this.createStrikeForm.zipCode) : null,
      };
    },
    async createOwnerCriminalRecordEntry(strikePayload) {
      const ownerId = this.company?.owner?.id;

      const evidenceUrlList = [];
      for (const ev of this.createStrikeEvidences) {
        if (ev.type === 'BASE64_IMAGE') {
          const response = await this.apiUploadEvidence(ev.image, 'evidence.png', null, true);
          evidenceUrlList.push(`- [Beweisfoto](${this.apiAttachmentUrl({id: response.data.id})})`);
        } else if (ev.type === 'URL') {
          evidenceUrlList.push(`- [Beweisfoto](${ev.image})`);
        }
      }

      const payload = this.buildOwnerRecordPayload(strikePayload, evidenceUrlList);
      return this.apiCreateCriminalRecordEntry(ownerId, payload);
    },
    onStrikeEvidencePaste(event) {
      const item = event.clipboardData?.items?.[0];
      if (!item) return;

      if (item.kind === 'file') {
        const file = item.getAsFile();
        this.toBase64(file).then(r => {
          this.createStrikeEvidences.push({title: 'Beweisfoto', type: 'BASE64_IMAGE', image: r});
        });
      } else if (item.kind === 'string') {
        item.getAsString(s => {
          const trimmed = (s || '').trim();
          if (trimmed.length > 0) {
            this.createStrikeEvidences.push({title: 'Beweisfoto', type: 'URL', image: trimmed});
          }
        });
      }
      this.createStrikeEvidenceInput = null;
    },
    onStrikeEvidenceUrlInput(val) {
      const trimmed = (val || '').trim();
      if (trimmed.length > 0) {
        this.createStrikeEvidences.push({title: 'Beweisfoto', type: 'URL', image: trimmed});
        this.createStrikeEvidenceInput = null;
      }
    },
    fetchFineRecords() {
      return this.apiGetAllFineRecords().then(r => {
        const records = Array.isArray(r?.data) ? r.data : [];
        this.fineRecords = records;
      }).catch(() => {
        this.fineRecords = [];
      });
    },
    openCreateStrikeDialog() {
      this.resetCreateStrikeForm();
      const leadingNumber = (this.company?.location || '').match(/^\d+/);
      if (leadingNumber) {
        this.createStrikeForm.zipCode = Number(leadingNumber[0]);
      }
      this.createStrikeModal = true;
    },
    closeCreateStrikeDialog() {
      this.createStrikeModal = false;
      this.resetCreateStrikeForm();
    },
    async createStrike() {
      const strikePayload = this.createStrikePayloadFromForm();

      if (!strikePayload.name || strikePayload.name.length === 0) {
        Swal.fire({
          icon: 'warning',
          title: 'Beschreibung fehlt',
          text: 'Bitte eine Beschreibung für den Strike angeben.',
        });
        return;
      }

      if (this.createStrikeForm.createCriminalRecord && !this.company?.owner?.id) {
        Swal.fire({
          icon: 'warning',
          title: 'Kein Inhaber hinterlegt',
          text: 'Für dieses Gewerbe ist kein Inhaber gesetzt. Criminal Record kann nicht automatisch erstellt werden.',
        });
        return;
      }

      this.saving = true;

      let criminalRecordError = null;

      try {
        if (this.createStrikeForm.createCriminalRecord) {
          try {
            const crResponse = await this.createOwnerCriminalRecordEntry(strikePayload);
            strikePayload.criminalRecordEntryId = crResponse?.data?.id || null;
          } catch (err) {
            criminalRecordError = err;
          }
        }

        await this.apiCompanyCreateStrike(this.company.id, strikePayload);

        this.closeCreateStrikeDialog();
        await this.fetchCompany();
        await this.fetchCriminalRecordEntryStatuses();

        if (criminalRecordError) {
          Swal.fire({
            icon: 'warning',
            title: 'Strike erstellt, Record fehlgeschlagen',
            text: criminalRecordError?.response?.data?.message || criminalRecordError?.message || 'Der Strike wurde erstellt, aber der Criminal Record konnte nicht angelegt werden.',
          });
        }
      } catch (err) {
        Swal.fire({
          icon: 'error',
          title: 'Strike konnte nicht erstellt werden',
          text: err?.response?.data?.message || err?.message || 'Unbekannter Fehler',
        });
      } finally {
        this.saving = false;
      }
    },
    resetCreateInspectionForm() {
      this.createInspectionForm = {
        note: '',
        followUp: false,
        followUpDays: 7,
      };
      this.createInspectionEvidences = [];
      this.createInspectionEvidenceInput = null;
    },
    openCreateInspectionDialog() {
      this.resetCreateInspectionForm();
      this.createInspectionModal = true;
    },
    closeCreateInspectionDialog() {
      this.createInspectionModal = false;
      this.resetCreateInspectionForm();
    },
    onInspectionEvidencePaste(event) {
      const item = event.clipboardData?.items?.[0];
      if (!item) return;

      if (item.kind === 'file') {
        const file = item.getAsFile();
        this.toBase64(file).then(r => {
          this.createInspectionEvidences.push({title: 'Beweisfoto', type: 'BASE64_IMAGE', image: r});
        });
      } else if (item.kind === 'string') {
        item.getAsString(s => {
          const trimmed = (s || '').trim();
          if (trimmed.length > 0) {
            this.createInspectionEvidences.push({title: 'Beweisfoto', type: 'URL', image: trimmed});
          }
        });
      }
      this.createInspectionEvidenceInput = null;
    },
    onInspectionEvidenceUrlInput(val) {
      const trimmed = (val || '').trim();
      if (trimmed.length > 0) {
        this.createInspectionEvidences.push({title: 'Beweisfoto', type: 'URL', image: trimmed});
        this.createInspectionEvidenceInput = null;
      }
    },
    async createInspection() {
      const followUp = Boolean(this.createInspectionForm.followUp);
      const followUpDays = Math.max(1, Number(this.createInspectionForm.followUpDays) || 7);

      this.saving = true;
      try {
        const attachmentIds = [];
        const urlEvidences = [];

        for (const ev of this.createInspectionEvidences) {
          if (ev.type === 'BASE64_IMAGE') {
            const response = await this.apiUploadEvidence(ev.image, 'inspection-evidence.png', 'Gewerbekontrolle', true);
            if (response?.data?.id) {
              attachmentIds.push(response.data.id);
            }
          } else if (ev.type === 'URL') {
            urlEvidences.push(ev.image);
          }
        }

        let note = (this.createInspectionForm.note || '').trim();
        if (urlEvidences.length > 0) {
          const urlNote = urlEvidences.map(url => `- ${url}`).join('\n');
          note = note ? `${note}\n\nBeweis-Links:\n${urlNote}` : `Beweis-Links:\n${urlNote}`;
        }

        await this.apiCompanyCreateInspection(this.company.id, {
          note,
          followUp,
          followUpDays,
          evidenceAttachmentIds: attachmentIds,
        });

        this.closeCreateInspectionDialog();
        await this.fetchCompany();
      } catch (err) {
        Swal.fire({
          icon: 'error',
          title: 'Kontrolle konnte nicht erstellt werden',
          text: err?.response?.data?.message || err?.message || 'Unbekannter Fehler',
        });
      } finally {
        this.saving = false;
      }
    },
    deleteInspection(inspection) {
      this.saving = true;
      this.apiCompanyDeleteInspection(this.company.id, inspection.id)
        .then(() => this.fetchCompany())
        .catch(err => {
          Swal.fire({
            icon: 'error',
            title: 'Kontrolle konnte nicht gelöscht werden',
            text: err?.response?.data?.message || err?.message || 'Unbekannter Fehler',
          });
        })
        .finally(() => {
          this.saving = false;
        });
    },
    updateCompany() {
      this.saving = true;

      Swal.fire({
        title: 'Update',
        html: 'Die Felder ' + (this.dirtyFields.toString()) + ' wurden geändert. Möchtest du diese wirklich aktualisieren?',
        showCancelButton: true,
        cancelButtonText: 'Abbrechen',
        confirmButtonText: 'Speichern',
      }).then(r => {
        if (r.isConfirmed) {
          let data = {};
          for (let fieldKey of this.dirtyFields) {
            data[fieldKey] = this.company[fieldKey];
          }
          this.apiUpdateCompany(this.companyId, data).then(() => {
            this.fetchCompany().finally(() => {
              this.saving = false;
            });
          })
        } else {
          this.saving = false;
        }
      })
    },
    fetchCompany() {
      return this.apiGetCompanyById(this.companyId).then(r => {
        this.company = r.data;

        if (!Array.isArray(this.company.licenseLinks)) {
          this.company.licenseLinks = [];
        }
        this.company.licenseLinks = this.normalizeLicenseLinks(this.company.licenseLinks);

        if (!Array.isArray(this.company.signLinks)) {
          this.company.signLinks = [];
        }
        this.company.signLinks = this.normalizeSignLinks(this.company.signLinks);

        if (!Array.isArray(this.company.inspections)) {
          this.company.inspections = [];
        }
        this.company.inspections = [...this.company.inspections].sort((a, b) => moment(b.createdAt).diff(moment(a.createdAt)));

        this.company.entries = this.company.entries.sort((b, a) => {
          return moment(a.createdAt).diff(b.createdAt);
        })

        this.companyUnmodified = JSON.parse(JSON.stringify(this.company));
      })
    },
    fetchCriminals() {
      return this.apiGetCriminalRecords().then(r => {
        this.criminals = r.data;
      })
    },
    fetchAvailableLicenses() {
      return this.apiGetCompanyLicenses().then(r => {
        const tableLicenses = Array.isArray(r.data) ? r.data : [];

        const dedupe = new Map();

        for (const lic of tableLicenses) {
          if (lic?.id && lic?.name) {
            dedupe.set(lic.id, {
              id: lic.id,
              name: lic.name,
              fee: Number(lic.fee) || 0,
              description: lic.description || '',
            });
          }
        }

        if (this.company && Array.isArray(this.company.licenseLinks)) {
          for (const link of this.company.licenseLinks) {
            const lic = link.license;
            if (lic?.id && lic?.name && !dedupe.has(lic.id)) {
              dedupe.set(lic.id, {
                id: lic.id,
                name: lic.name,
                fee: Number(lic.fee) || 0,
                description: lic.description || '',
              });
            }
          }
        }

        this.availableLicenses = Array.from(dedupe.values()).sort((a, b) => a.name.localeCompare(b.name, 'de'));
      }).catch(() => {
        const fallback = [];
        if (this.company && Array.isArray(this.company.licenseLinks)) {
          for (const link of this.company.licenseLinks) {
            if (link.license?.id && link.license?.name) {
              fallback.push({
                id: link.license.id,
                name: link.license.name,
                fee: Number(link.license.fee) || 0,
                description: link.license.description || '',
              });
            }
          }
        }

        const uniqueById = new Map();
        fallback.forEach(v => uniqueById.set(v.id, v));
        this.availableLicenses = Array.from(uniqueById.values()).sort((a, b) => a.name.localeCompare(b.name, 'de'));
      })
    },
    normalizeSignLinks(links) {
      const source = Array.isArray(links) ? links : [];
      const dedupe = new Map();

      for (const rawLink of source) {
        const rawSign = rawLink?.sign || {};
        const signId = rawSign.id || null;
        if (!signId) continue;

        dedupe.set(signId, {
          id: rawLink?.id || this.createClientId(),
          sign: this.normalizeSign(rawSign),
        });
      }

      return Array.from(dedupe.values());
    },
    fetchAvailableSigns() {
      return this.apiGetAvailableCompanySigns(this.companyId).then(r => {
        const tableSigns = Array.isArray(r.data) ? r.data : [];

        const dedupe = new Map();
        for (const sign of tableSigns) {
          if (!sign?.id) continue;
          dedupe.set(sign.id, {
            ...this.normalizeSign(sign),
          });
        }

        if (this.company && Array.isArray(this.company.signLinks)) {
          for (const link of this.company.signLinks) {
            const sign = link?.sign;
            if (sign?.id && !dedupe.has(sign.id)) {
              dedupe.set(sign.id, {
                ...this.normalizeSign(sign),
              });
            }
          }
        }

        this.availableSigns = Array.from(dedupe.values()).sort((a, b) => (a.iid || 0) - (b.iid || 0));
      }).catch(() => {
        const fallback = [];
        if (this.company && Array.isArray(this.company.signLinks)) {
          for (const link of this.company.signLinks) {
            const sign = link?.sign;
            if (!sign?.id) continue;
            fallback.push({
              ...this.normalizeSign(sign),
            });
          }
        }

        const uniqueById = new Map();
        fallback.forEach(v => uniqueById.set(v.id, v));
        this.availableSigns = Array.from(uniqueById.values()).sort((a, b) => (a.iid || 0) - (b.iid || 0));
      });
    },
    modifyEvent_nextPaymentLicenses(val) {
      if (val) {
        this.company.nextPaymentLicenses = moment(val).startOf('d').add(18, 'h').toISOString(true);
      } else {
        this.company.nextPaymentLicenses = null;
      }
    },
    modifyEvent_vacatedUntil(val) {
      if (val) {
        this.company.vacatedUntil = moment(val).endOf('d').toISOString(true);
      } else {
        this.company.vacatedUntil = null;
      }
    },
    datePickerValue(val) {
      if (!val) {
        return null;
      }
      let date = moment(val);
      return date.toISOString(true).substring(0, 10);
    },
    removeRepresentative(rep) {
      this.saving = true;
      this.apiCompanyRemoveRepresentative(this.company, rep).then(() => {
        return this.fetchCompany();
      }).finally(() => {
        this.saving = false;
      })
    },
    addRepresentative() {
      this.saving = true;
      this.apiCompanyAddRepresentative(this.company, this.addRepresentativeRecord).then(() => {
        return this.fetchCompany();
      }).finally(() => {
        this.addRepresentativeRecord = null;
        this.addRepresentativeModal = false;
        this.saving = false;
      })
    },
    formatMoney(val) {
      return new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
      }).format(Number(val) || 0);
    },
    resolveLicenseDescription(licenseLink) {
      const licenseId = licenseLink?.license?.id;
      const licenseName = (licenseLink?.license?.name || '').trim();
      const source = Array.isArray(this.availableLicenses) ? this.availableLicenses : [];

      let masterLicense = null;

      if (licenseId !== undefined && licenseId !== null && `${licenseId}`.length > 0) {
        const normalizedId = `${licenseId}`;
        masterLicense = source.find(lic => `${lic?.id || ''}` === normalizedId);
      }

      if (!masterLicense && licenseName.length > 0) {
        const normalizedName = licenseName.toLowerCase();
        masterLicense = source.find(lic => `${lic?.name || ''}`.trim().toLowerCase() === normalizedName);
      }

      const description = masterLicense?.description;
      return description && `${description}`.trim().length > 0 ? `${description}`.trim() : '';
    },
    resolveLicenseName(licenseLink) {
      const licenseId = licenseLink?.license?.id;
      const source = Array.isArray(this.availableLicenses) ? this.availableLicenses : [];

      if (licenseId === undefined || licenseId === null || `${licenseId}`.length === 0) {
        return '';
      }

      const masterLicense = source.find(lic => `${lic?.id || ''}` === `${licenseId}`);
      return `${masterLicense?.name || ''}`.trim();
    },
    displayLicenseDescription(licenseLink) {
      const masterDescription = this.resolveLicenseDescription(licenseLink);
      if (masterDescription) {
        return masterDescription;
      }

      const linkDescription = `${licenseLink?.license?.description || ''}`.trim();
      if (linkDescription.length > 0) {
        return linkDescription;
      }

      return 'Keine Beschreibung hinterlegt';
    },
    createClientId() {
      if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID();
      }

      return 'lic-' + Date.now() + '-' + Math.random().toString(36).substring(2, 12);
    },
    normalizeLicenseLinks(links) {
      const source = Array.isArray(links) ? links : [];
      const grouped = new Map();

      for (const rawLink of source) {
        const rawLicense = rawLink?.license || {};
        const licenseId = rawLicense.id || null;
        const licenseName = rawLicense.name || 'Unbekannter Kostenpunkt';
        const key = licenseId || `name:${licenseName}`;

        const normalizedCount = Math.max(1, Number(rawLink?.count) || 1);
        const normalizedFee = Math.max(0, Number(rawLicense.fee) || 0);

        if (!grouped.has(key)) {
          grouped.set(key, {
            id: rawLink?.id || this.createClientId(),
            count: normalizedCount,
            license: {
              id: licenseId,
              name: licenseName,
              fee: normalizedFee,
              description: rawLicense.description || '',
            }
          });
        } else {
          const existing = grouped.get(key);
          existing.count += normalizedCount;
          existing.license.fee = normalizedFee;
          if (!existing.license.description && rawLicense.description) {
            existing.license.description = rawLicense.description;
          }
        }
      }

      return Array.from(grouped.values());
    },
    onLicenseTemplateChanged(selectedLicense) {
      this.newLicensePrice = Number(selectedLicense?.fee) || 0;
    },
    addLicense() {
      if (this.saving || this.editLicenseSaving) return;
      if (!this.selectedLicenseTemplate?.id) return;

      const selectedLicenseId = this.selectedLicenseTemplate.id;
      this.saving = true;

      this.apiCompanySetLicense(this.companyId, selectedLicenseId)
        .then(() => this.fetchCompany())
        .then(() => this.fetchAvailableLicenses())
        .then(() => this.fetchAvailableSigns())
        .then(() => {
          this.selectedLicenseTemplate = null;
          this.newLicensePrice = 0;
        })
        .catch(err => {
          Swal.fire({
            icon: 'error',
            title: 'Kostenpunkt konnte nicht hinzugefügt werden',
            text: err?.response?.data?.message || err?.message || 'Unbekannter Fehler',
          });
        })
        .finally(() => {
          this.saving = false;
        });
    },
    removeLicense(licenseLink) {
      if (this.saving || this.editLicenseSaving) return;
      const linkId = licenseLink?.id;
      const licenseId = licenseLink?.license?.id;

      if (linkId) {
        this.saving = true;

        this.apiCompanyRemoveLicenseLink(this.companyId, linkId)
          .then(() => this.fetchCompany())
          .then(() => this.fetchAvailableLicenses())
          .then(() => this.fetchAvailableSigns())
          .catch(err => {
            Swal.fire({
              icon: 'error',
              title: 'Kostenpunkt konnte nicht gelöscht werden',
              text: err?.response?.data?.message || err?.message || 'Unbekannter Fehler',
            });
          })
          .finally(() => {
            this.saving = false;
          });

        return;
      }

      const removeCount = Math.max(1, Number(licenseLink?.count) || 1);

      if (!licenseId) {
        const index = this.company.licenseLinks.indexOf(licenseLink);
        if (index >= 0) {
          this.company.licenseLinks.splice(index, 1);
        }
        return;
      }

      this.saving = true;

      const removeRepeated = async () => {
        for (let i = 0; i < removeCount; i++) {
          await this.apiCompanyRemoveLicense(this.companyId, licenseId);
        }
      };

      removeRepeated()
        .then(() => this.fetchCompany())
        .then(() => this.fetchAvailableLicenses())
        .then(() => this.fetchAvailableSigns())
        .catch(err => {
          Swal.fire({
            icon: 'error',
            title: 'Kostenpunkt konnte nicht gelöscht werden',
            text: err?.response?.data?.message || err?.message || 'Unbekannter Fehler',
          });
        })
        .finally(() => {
          this.saving = false;
        });
    },
    openLicensePriceDialog(licenseLink) {
      this.editLicenseLink = licenseLink;
      const masterLicense = (Array.isArray(this.availableLicenses) ? this.availableLicenses : [])
        .find(lic => `${lic?.id || ''}` === `${licenseLink?.license?.id || ''}`);
      this.editLicensePrice = Number(masterLicense?.fee ?? licenseLink?.license?.fee) || 0;
      this.editLicenseCount = Math.max(1, Number(licenseLink?.count) || 1);
      this.editLicenseOriginalCount = this.editLicenseCount;
      this.editLicenseModal = true;
    },
    closeLicensePriceDialog(forceClose = false) {
      if (this.editLicenseSaving && !forceClose) return;
      this.editLicenseModal = false;
      this.editLicenseLink = null;
      this.editLicensePrice = 0;
      this.editLicenseCount = 1;
      this.editLicenseOriginalCount = 1;
    },
    async runLicenseOperationRepeated(times, operationFactory) {
      const safeTimes = Math.max(0, Number(times) || 0);
      for (let i = 0; i < safeTimes; i++) {
        await operationFactory();
      }
    },
    async saveEditedLicensePrice() {
      if (this.editLicenseSaving || this.saving) return;
      if (!this.editLicenseLink?.id) {
        if (!this.editLicenseLink?.license?.id) {
          if (this.editLicenseLink?.license) {
            this.editLicenseLink.count = Math.max(1, Number(this.editLicenseCount) || 1);
          }
          this.closeLicensePriceDialog();
          return;
        }

        if (this.editLicenseLink?.license) {
          this.editLicenseLink.count = Math.max(1, Number(this.editLicenseCount) || 1);
        }
        this.closeLicensePriceDialog();
        return;
      }

      const linkId = this.editLicenseLink.id;
      const oldCount = Math.max(1, Number(this.editLicenseOriginalCount) || 1);
      const newCount = Math.max(1, Number(this.editLicenseCount) || 1);

      if (oldCount === newCount) {
        this.closeLicensePriceDialog();
        return;
      }

      this.saving = true;
      this.editLicenseSaving = true;

      try {
        await this.apiCompanyUpdateLicenseLink(this.companyId, linkId, {
          count: newCount,
        });

        await this.fetchCompany();
        this.closeLicensePriceDialog(true);
      } catch (err) {
        Swal.fire({
          icon: 'error',
          title: 'Kostenpunkt konnte nicht gespeichert werden',
          text: err?.response?.data?.message || err?.message || 'Unbekannter Fehler',
        });
      } finally {
        this.editLicenseSaving = false;
        this.saving = false;
      }
    },
    addSign() {
      if (this.saving || this.editLicenseSaving) return;
      if (!this.selectedSignTemplate?.id) return;

      this.saving = true;
      this.apiCompanySetSign(this.companyId, this.selectedSignTemplate.id)
        .then(() => this.fetchCompany())
        .then(() => this.fetchAvailableSigns())
        .then(() => {
          this.selectedSignTemplate = null;
        })
        .catch(err => {
          Swal.fire({
            icon: 'error',
            title: 'Werbeschild konnte nicht zugewiesen werden',
            text: err?.response?.data?.message || err?.message || 'Unbekannter Fehler',
          });
        })
        .finally(() => {
          this.saving = false;
        });
    },
    removeSign(signLink) {
      if (this.saving || this.editLicenseSaving) return;
      const linkId = signLink?.id;
      if (!linkId) return;

      this.saving = true;
      this.apiCompanyRemoveSignLink(this.companyId, linkId)
        .then(() => this.fetchCompany())
        .then(() => this.fetchAvailableSigns())
        .catch(err => {
          Swal.fire({
            icon: 'error',
            title: 'Werbeschild konnte nicht entfernt werden',
            text: err?.response?.data?.message || err?.message || 'Unbekannter Fehler',
          });
        })
        .finally(() => {
          this.saving = false;
        });
    }
  },
  mounted() {
    this.companyId = this.$route.params.id;
    this.fetchCompany().then(() => Promise.all([
      this.fetchAvailableLicenses(),
      this.fetchAvailableSigns(),
      this.fetchCriminalRecordEntryStatuses(),
    ]));
    this.fetchCriminals();
    this.fetchFineRecords();
  },
  watch: {
    company: {
      deep: true,
      handler: function (val, oldVal) {
        if (val && oldVal) {
          for (let valKey in val) {
            if (['strikes', 'accessTokens', 'authorizedRepresentatives', 'createdBy', 'entries', 'licenseLinks', 'signLinks'].includes(valKey)) continue;

            if (valKey === 'owner') {
              let oOwner = this.companyUnmodified[valKey];
              let nOwner = val[valKey];

              if (oOwner?.id !== nOwner?.id) {
                this.dirtyFields.push(valKey);
              } else if (this.dirtyFields.includes(valKey)) {
                this.dirtyFields.splice(this.dirtyFields.indexOf(valKey), 1);
              }
              continue;
            }

            let newVal = val[valKey];
            let origVal = this.companyUnmodified[valKey];

            if (newVal != origVal && !this.dirtyFields.includes(valKey)) {
              this.dirtyFields.push(valKey);
            } else if (newVal == origVal && this.dirtyFields.includes(valKey)) {
              this.dirtyFields.splice(this.dirtyFields.indexOf(valKey), 1);
            }
          }
        }
      }
    }
  }
}
</script>